import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ConversionAssistant } from "@/components/ConversionAssistant";
import { QuoteButton } from "@/components/QuoteButton";
import { Phone } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const STICKY = {
  "/mariages": { service: "Traiteur uniquement", eventType: "Mariage ou cérémonie" },
  "/cheffe-a-domicile": { service: "Cheffe à domicile" },
  "/coordination": { service: "Coordination événementielle uniquement" },
  "/traiteur": { service: "Traiteur uniquement" },
  "/catering-production": { service: "Traiteur uniquement", eventType: "Production, tournage ou spectacle" },
};

export default function PublicLayout() {
  const { pathname } = useLocation();
  const onDevis = pathname.startsWith("/devis");
  const { content } = useContent();
  const phone = content?.contact?.phone || "06 41 28 33 85";
  const telHref = phone.replace(/[^\d+]/g, "");
  return (
    <div className="min-h-screen bg-[#FAF6EF]">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <div className="h-[76px] bg-[#2C2C2C] lg:hidden" aria-hidden="true" />
      {!onDevis && <ConversionAssistant />}
      {/* Sticky mobile call + quote bar */}
      <div className="fixed bottom-0 left-0 right-0 z-40 flex gap-2 border-t border-[#2C2C2C]/10 bg-[#FAF6EF]/95 p-3 backdrop-blur-md lg:hidden" data-testid="sticky-mobile-bar">
        <a href={`tel:${telHref}`} data-testid="sticky-mobile-call" aria-label={`Nous appeler au ${phone}`} className={`inline-flex items-center justify-center gap-2 rounded-full border border-[#2C2C2C] px-5 py-3 text-sm font-medium text-[#2C2C2C] transition-colors active:bg-[#2C2C2C] active:text-white ${onDevis ? "w-full" : "shrink-0"}`}>
          <Phone size={16} className="text-[#C9A84C]" /> Nous appeler
        </a>
        {!onDevis && <QuoteButton testId="sticky-mobile-quote" className="flex-1 justify-center" {...(STICKY[pathname] || {})} />}
      </div>
    </div>
  );
}
